var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucessOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.668,
    height: 26.584,
    viewBox: "0 0 39.668 26.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-done-outline",
    d: "M82.018,128,63.7,148.934l-7.85-7.85m0,7.85L48,141.084M74.167,128,63.046,140.757",
    transform: "translate(-45.172 -125.178)",
    fill: "none",
    stroke: "#0eb908",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessOutlineIcon);
export default __webpack_public_path__ + "static/media/sucess-outline-icon.e529544d51a980f499355bac18ac18e3.svg";
export { ForwardRef as ReactComponent };